import { ContentfulLearningPath, ContentfulLearningPathSummary } from 'src/graphql/queries/GetLearningPath';
import { ContentfulSmCourse, ContentfulSmCourseOverview } from 'src/graphql/queries/GetSmCourse';
import { GetLearningPathId } from 'src/graphql/queries/GetLearningPathId';

export type ContentHeaderData = {
  title: string;
  tagline?: string;
  product?: string[];
  productRole?: string[];
  learningPathSummary?: ContentfulLearningPathSummary;
  overview?: ContentfulSmCourseOverview;
};

const EXTENDED_CONTENT_HEADER_PATHS = [
  'registered-scrum-basics',
  'vy-new-learning-path-2',
  'use-scrum-events-to-deliver-work-in-time-boxed-increments',
];

export const getContentHeaderContent = (
  content: ContentfulLearningPath | GetLearningPathId | ContentfulSmCourse,
  isLearningPath: boolean,
  currentUrl?: string,
): ContentHeaderData => {
  if (isLearningPath) {
    const learningPath = content as ContentfulLearningPath;

    const showLearningPathSummary =
      currentUrl && EXTENDED_CONTENT_HEADER_PATHS.some((path) => currentUrl.includes(path));

    return {
      title: learningPath.title ?? '',
      tagline: learningPath.learningPathTagline ?? '',
      product: learningPath.product ?? [],
      productRole: learningPath.productRole ?? [],
      learningPathSummary: showLearningPathSummary ? learningPath.learningPathSummary : undefined,
    };
  }

  const course = content as ContentfulSmCourse;

  const showOverview = currentUrl && EXTENDED_CONTENT_HEADER_PATHS.some((path) => currentUrl.includes(path));

  return {
    title: course.title ?? '',
    tagline: course.teaser ?? '',
    product: course.product ?? [],
    productRole: course.productRole ?? [],
    overview: showOverview ? course.overview : undefined,
  };
};
